
import type { Candidate } from "./types";
import CandidateTableRow from "./CandidateTableRow";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import { Mail, UserCheck, Briefcase, MoreHorizontal, Building2, Link, FileSearch, Hash } from "lucide-react";

interface CandidateTableProps {
  candidates: Candidate[];
}

export const CandidateTable = ({ candidates }: CandidateTableProps) => {
  if (candidates.length === 0) {
    return (
      <div className="text-center py-10 text-muted-foreground">
        No candidates found matching your criteria.
      </div>
    );
  }
  
  return (
    <div className="overflow-x-auto rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[100px]">
              <div className="font-medium flex items-center gap-2">
                <Hash className="h-4 w-4" />
                <span>ID</span>
              </div>
            </TableHead>
            <TableHead className="w-[200px]">
              <div className="font-medium">Name</div>
            </TableHead>
            <TableHead className="hidden md:table-cell">
              <div className="font-medium flex items-center gap-2">
                <Building2 className="h-4 w-4" />
                <span>Current Role</span>
              </div>
            </TableHead>
            <TableHead className="hidden md:table-cell">
              <div className="font-medium flex items-center gap-2">
                <Link className="h-4 w-4" />
                <span>Source</span>
              </div>
            </TableHead>
            <TableHead>
              <div className="font-medium flex items-center gap-2">
                <UserCheck className="h-4 w-4" />
                <span>Status</span>
              </div>
            </TableHead>
            <TableHead className="hidden lg:table-cell">
              <div className="font-medium flex items-center gap-2">
                <Briefcase className="h-4 w-4" />
                <span>Assigned Job</span>
              </div>
            </TableHead>
            <TableHead className="hidden lg:table-cell">
              <div className="font-medium flex items-center gap-2">
                <FileSearch className="h-4 w-4" />
                <span>Best Match</span>
              </div>
            </TableHead>
            <TableHead className="w-[80px]">
              <div className="font-medium flex items-center justify-end">
                <MoreHorizontal className="h-4 w-4" />
                <span className="sr-only">Actions</span>
              </div>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {candidates.map((candidate) => (
            <CandidateTableRow key={candidate.id} candidate={candidate} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
